import React from 'react';

const CardiologiaIcon = (props) => {
  const fill = props ? props.color : '#294C76';
  return (
    <svg
      width="20"
      height="18"
      viewBox="0 0 20 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M6.96173 15.9687C4.01943 13.7137 0 9.9886 0 6.46653C0 0.582622 5.50016 -1.61414 10 2.93111C14.4998 -1.61414 20 0.582622 20 6.4665C20 9.98866 15.9806 13.7137 13.0383 15.9687C11.7063 16.9896 11.0403 17.5 10 17.5C8.95972 17.5 8.29372 16.9896 6.96173 15.9687ZM14.5 3.75C14.9142 3.75 15.25 4.08579 15.25 4.5V5.75002H16.5C16.9142 5.75002 17.25 6.0858 17.25 6.50002C17.25 6.91423 16.9142 7.25002 16.5 7.25002H15.25V8.5C15.25 8.91421 14.9142 9.25 14.5 9.25C14.0858 9.25 13.75 8.91421 13.75 8.5V7.25002L12.5 7.25002C12.0858 7.25002 11.75 6.91423 11.75 6.50002C11.75 6.0858 12.0858 5.75002 12.5 5.75002H13.75V4.5C13.75 4.08579 14.0858 3.75 14.5 3.75Z"
        fill={fill}
      />
    </svg>
  );
};

export default CardiologiaIcon;
